import version from "@/base/version/version";
import getApplicationEnvironment from "@/utils/getApplicationEnvironment";

const SAMPLED_USERS_PRODUCTION = 2;
const SAMPLED_USERS_DEV = 100;

export const rumConfig = {
  SAMPLED_USERS_PRODUCTION,
  SAMPLED_USERS_DEV,
};

// When registering the Lyceum application version with Datadog, use the latest
// git tag. Unless the latest tag does not exist or does not point to the
// latest commit. In which case, use the latest commit hash instead.
export const versionForDatadog =
  version.gitRepository.latestTag &&
  Number(version.gitRepository.numberOfCommitsSinceLatestTag) === 0
    ? version.gitRepository.latestTag
    : version.gitRepository.commit;

export const getSampleRate = () => {
  const envSampleRate = Number(
    process.env["NEXT_PUBLIC_DATADOG_RUM_SAMPLE_RATE"],
  );
  if (!isNaN(envSampleRate)) {
    // Always prefer env var setting if it's available.
    return envSampleRate;
  }
  // Use env-based constants when the RUM sampling env var is not set.
  const { environment } = getApplicationEnvironment();
  if (environment === "production") {
    return rumConfig.SAMPLED_USERS_PRODUCTION;
  }
  return rumConfig.SAMPLED_USERS_DEV;
};

export const getLoggingSampleSessionRate = () => {
  const sessionSampleRate = Number(
    process.env["NEXT_PUBLIC_DATADOG_BROWSER_SAMPLE_RATE"],
  );
  return !isNaN(sessionSampleRate) ? sessionSampleRate : 100;
};

export const isRumEnabled = () => {
  const { isProductionEnv } = getApplicationEnvironment();
  /*
   * Always prefer to use env var if it's available.
   * Enable RUM on production if there is no valid env var setting.
   */
  return (
    process.env["NEXT_PUBLIC_DATADOG_IS_RUM_ENABLED"] === "true" ||
    isProductionEnv
  );
};

export const isLoggingEnabled = () => {
  return process.env["NEXT_PUBLIC_DATADOG_IS_LOGGING_ENABLED"] === "true";
};
